import Vue from 'vue'
import axios from 'axios'
import chatHelpers from '../../helpers/chatHelpers'

const vueObj = new Vue()

const state = {
  messages: null,
  maxImagesLength: 0,
  loadedImagesLength: 0,
  performScroll: false
}

const getMaxImagesLength = (messages) => {
  let count = 0
  for (const message of messages) {
    if (message.attachments.length) {
      const ext = chatHelpers.getUrlExtension(message.attachments[0].url)
      if (['jpg', 'jpeg', 'png', 'gif'].indexOf(ext) >= 0) {
        count += 1
      }
    }
  }
  return count
}

const actions = {
  fetchMessages: ({ commit }, params) => {
    return new Promise(async (resolve, reject) => {
      if (params.page === 0) {
        commit('SET_MESSAGES', [])
      } else {
        commit('SET_LOADING_MESSAGES')
      }
      const url = '/messages'
      const res = await axios.get(url, { params })
      if (res.status === 200) {
        const messages = res.data
        if (messages.length > 0) {
          const timeout = (params.page === 0) ? 300 : 1000
          setTimeout(() => {
            if (params.page === 0) {
              commit('SET_MESSAGES', messages)
            } else {
              commit('SET_MORE_MESSAGES', messages)
            }
            commit('CHECK_IMAGE_MESSAGES', messages)
            resolve('success')
          }, timeout)
        } else {
          commit('REMOVE_LOADING_MESSAGES')
          resolve('success')
        }
      } else {
        reject(res.data.error)
        throw new Error(res.data.error)
      }
    }).catch(res => {
      vueObj.$swal({ text: res.message })
    })
  },
  // Returns its outcome instead of swallowing it, so a caller can revert its optimistic is_sent = 0
  // on a 400. Still never throws, so no existing caller can break on it.
  resendMessage: async ({ commit }, id) => {
    try {
      const url = `/messages/${id}/resend`
      const res = await axios.post(url)
      return { ok: true, data: res.data }
    } catch (error) {
      console.log('check resendMessage', error)
      const data = (error.response && error.response.data) ? error.response.data : {}
      return { ok: false, error: error, reason: data.reason || null, message: data.error || null }
    }
  }
}

const mutations = {
  SET_MESSAGES: (state, messages) => {
    if (state.messages) {
      state.messages.shift()
    }
    state.messages = messages
  },
  SET_MORE_MESSAGES: (state, messages) => {
    state.messages.shift()
    state.messages = [...messages, ...state.messages]
  },
  SET_LOADING_MESSAGES: (state) => {
    state.messages.unshift({ id: 0 })
    state.messages = [...state.messages]
  },
  REMOVE_LOADING_MESSAGES: (state) => {
    state.messages.shift()
  },
  UPDATE_NEW_MESSAGE: (state, message) => {
    let isNewMessage = true
    for (const key in state.messages) {
      if (state.messages[key].id === message.id) {
        state.messages[key] = message
        isNewMessage = false
        break
      }
    }
    if (isNewMessage) {
      // Update new message
      state.messages.push(message)
    } else {
      state.messages = [...state.messages]
    }
  },
  CHECK_IMAGE_MESSAGES: (state, messages) => {
    // Get image qty
    state.performScroll = false
    state.loadedImagesLength = 0
    state.maxImagesLength = getMaxImagesLength(messages)
    if (!state.maxImagesLength) {
      setTimeout(() => {
        state.performScroll = true
      }, 250)
    }
  },
  COUNT_LOADED_IMAGE: (state) => {
    state.loadedImagesLength += 1
    if (state.loadedImagesLength === state.maxImagesLength) {
      state.performScroll = true
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
